<template>
  <v-container
    fluid
    grid-list-md
    v-if="$store.state.authenticated"
    style="padding-top: 72px; padding-bottom: 48px"
  >
    <v-layout align-space-between column>
      <v-card>
        <v-card-text>
          <h1 style="color: #ff0000">
            SUPERADMIN
          </h1>
          <datatable-dsbs/>
           <datatable-superadmins />
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import DatatableDsbsVue from '../components/DatatableDsbs.vue';
import DatatableSuperAdminVue from '../components/DatatableSuperAdmins.vue';

export default {
  name: "Superadmin",

  components: {
    'datatable-dsbs': DatatableDsbsVue,
    'datatable-superadmins': DatatableSuperAdminVue
  },

  mounted() {
    if(!this.userRole) {
      window.location.href = location.protocol + '//' + location.host + '/wst/#/login';
    }
  },

  computed: {
    userRole() {
      return this.$store.state.userRole;
    }
  }
};
</script>
<style scoped>
.container {
  height: 100%;
}
</style>
